export default __webpack_public_path__ + "static/media/Login.6af3cf29.svg";